import { customAlphabet } from 'nanoid';
import { identity, iots, string } from '@code-expert/prelude';
/**
 * These characters are chosen to be unmistakable when reading them.
 */
export const ID_CHARS = '23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz';
export const IdRegExp = new RegExp(`^[${ID_CHARS}]{17}$`);
export class EntityIdC extends iots.Type {
    _tag = 'EntityIdType';
}
export const genEntityId = () => customAlphabet(ID_CHARS)(17);
export const isEntityId = (u) => string.isString(u) && IdRegExp.test(u);
/**
 * Creates a branded EntityId codec that respects Meteor's rules for Mongo document IDs and
 * produces nominal ID types that can't be accidentally mixed up with each other.
 */
export const mkEntityIdCodec = (sym) => {
    const is = (u) => isEntityId(u);
    return new EntityIdC(sym.description ?? sym.toString(), is, (u, c) => (is(u) ? iots.success(u) : iots.failure(u, c)), String);
};
/**
 * Creates an EntityId from a literal using a type assertion.
 * Caution: The input is not validated; use this function only when it is guaranteed that the
 * input represents a valid value.
 */
export const fromLiteral = identity;
//# sourceMappingURL=identity.js.map